import {
	Button,
	CardContent,
	CardMedia,
	Grid,
	Typography,
	Tooltip,
} from '@mui/material'
import { BusinessInfoCard } from './BusinessInfoCard'
import ButtonCustom from '../../atoms/button/ButtonCustom'
import { MediaCard } from './MediaCard'
import { ServicesCard } from './ServicesCard'
import { SocialProfilesCard } from './SocialProfilesCard'
import { RatingReviewCard } from './RatingReviewCard'

import styles from './index.module.scss'
import { VisuallyHiddenInput } from '../../uploadFile/VisuallyHiddenFileInput'
import CommonModal from '../../atoms/modal/CommonModal'
import Stepper from '../../atoms/Stepper/Stepper'
import WeddingSelect from '../../../pages/vendors-list/Modals/WeddingSelect'
import BudgetRange from '../../../pages/vendors-list/Modals/BudgetRange'
import ProposalSummary from '../../../pages/vendors-list/Modals/ProposalSummary'
import { useState, useCallback } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { closeModal, openModal } from '../../../features/commonSlice'
import { requestProposal } from '../../../features/proposalSlice'
import { toastHelper } from '../../../util/toastHelper'
import { toggleFavoriteVendor } from '../../../features/kazooEventSlice'
import { setSettingsTab } from '../../../features/authSlice'
import { notifyUser } from '../../../features/notificationSlice'
import { BusinessDesCard } from './BusinessDesCard'
import PackagesCard from './PackagesCard'
const defaultCover =
	'https://static.vecteezy.com/system/resources/previews/021/686/124/large_2x/blue-background-high-resolution-wallpaper-free-free-photo.jpg'

export const VendorPublicProfileV2 = ({
	formData = {
		businessAddress: 'Dolores incididunt l',
		businessName: 'Amity Woods',
		businessProfilePic: ' /images/vendor-card-img.png',
		businessTypes: ['Caterer'],
		numEmployees: 100,
		services: ['Bridal Bouquet', 'Boutonnieres'],
		maxCapacity: 150,
		websiteLink: '',
		businessDescription: '',
	},
	handleFileChange = () => { },
	setFormData = () => { },
	editable = false,
	setIsDetailsOpen = () => { },
	showBackButton = true,
	vendorId = null,
	reviewsData = null,
	sameUser = false,
	canEditBusinessDetails = false,
}) => {
	const navigate = useNavigate()
	const dispatch = useDispatch()
	const isProfileIncomplete = !formData?.profileCompleted
	const { userId } = useParams()
	const accountType = useSelector((state) => state.auth.accountType)
	const user = useSelector((state) => state.auth.user)
	const curUserId = user?._id
	const modal = useSelector((state) => state.common.modal)
	const cardStyle = {
		display: 'flex',
		flexDirection: 'column',
		borderRadius: '1em',
		padding: '1.5em',
		margin: '1em',
	}

	const isMyProfile = userId === curUserId

	const [activeStep, setActiveStep] = useState(0)
	const [selectedKazoo, setSelectedKazoo] = useState(null)
	const [selectedPackage, setSelectedPackage] = useState(null)

	const handleBackNavigate = () => {
		setIsDetailsOpen(false)
		navigate(-1)
	}

	const closeAllModals = () => {
		setActiveStep(0)
		dispatch(closeModal())
		setSelectedKazoo(null)
		setSelectedPackage(null)
	}

	const handleNext = () => {
		if (activeStep === 1) {
			if (!selectedKazoo?.kazooName)
				return toastHelper('Must choose a wedding', 'error')
			if (!selectedKazoo?.startDate)
				return toastHelper('Start date required', 'error')
			else if (!selectedKazoo?.endDate)
				return toastHelper('End date required', 'error')
			else if (
				new Date(selectedKazoo?.startDate) < new Date() ||
				new Date(selectedKazoo?.endDate) < new Date()
			)
				return toastHelper(
					'Selected date must be greater than current date',
					'error'
				)
			else if (
				new Date(selectedKazoo?.startDate) >
				new Date(selectedKazoo?.endDate)
			)
				return toastHelper(
					'End date must be greater than start date',
					'error'
				)
		} else if (activeStep === 0) {
			if (!selectedPackage && !selectedKazoo?.userBudget)
				return toastHelper(
					'Please fill a Budget or select a Package',
					'error'
				)
		}
		setActiveStep((prevStep) => (prevStep >= 3 ? prevStep : prevStep + 1))
	}
	const handleBack = () => {
		setActiveStep((prevStep) => (prevStep <= 0 ? prevStep : prevStep - 1))
	}

	const handleFavoriteClick = (e) => {
		e.preventDefault()
		e.stopPropagation()
		dispatch(openModal('addFavoriteVendorModal2'))
	}

	const handleSubmitFav = () => {
		if (selectedKazoo?._id && userId) {
			dispatch(
				toggleFavoriteVendor({
					kazooId: selectedKazoo._id,
					vendorId: userId,
				})
			)
			closeAllModals()
		}
	}

	const handleNotify = useCallback(async () => {
		const targetId = userId || vendorId
		if (!targetId) return

		const senderName =
			`${user?.firstName || ''} ${user?.lastName || ''}`.trim() ||
			'A user'

		try {
			const { success, message } = await dispatch(
				notifyUser({
					receiverId: targetId,
					type: 'Profile Completion Request',
					message: `${senderName}|Request to complete profile`,
				})
			).unwrap()

			if (success) {
				toastHelper(
					message || 'Notification sent successfully',
					'success'
				)
			} else {
				toastHelper(message || 'Failed to notify user', 'error')
			}
		} catch (err) {
			toastHelper(err?.message || 'Something went wrong', 'error')
		}
	}, [dispatch, user, userId, vendorId])
	return (
		<>
			<section className={styles.vendorDetailWrp}>
				{showBackButton && (
					<div
						className={styles.backBtn}
						onClick={handleBackNavigate}
					>
						<img src="/images/arrow-left.svg" alt="back.svg" />
						<span>Back</span>
					</div>
				)}
				<div
					className={styles.contentContainer}
					style={{ position: 'relative' }}
				>
					<div className={styles.topContent}>
						<div className={`${styles.coverImgWrp}`}>
							{['user'].includes(accountType) && (
								<ButtonCustom
									className={styles.favoriteBtn}
									variant="outlined"
									size="sm"
									onClick={handleFavoriteClick}
								>
									<img src="/images/heart.svg" alt="heart" />
									Favorite
								</ButtonCustom>
							)}
							{editable && (
								<Button
									sx={{
										position: 'absolute',
										right: '12px',
										top: '12px',
										borderRadius: '0.5rem',
										backgroundColor: 'white',
										textTransform: 'none',
										':hover': {
											backgroundColor: '#f4f4f4ff',
										},
									}}
									component="label"
									variant="outlined"
									tabIndex={-1}
									startIcon={
										<>
											<img
												src="/images/camera.svg"
												alt="cover"
											/>
										</>
									}
								>
									Change Cover
									<VisuallyHiddenInput
										type="file"
										accept=".jpg, .png"
										onChange={(e) => handleFileChange(e, 1)}
										multiple
									/>
								</Button>
							)}
							<CardMedia
								image={formData.coverPic || defaultCover}
								className={styles.coverImg}
							/>
						</div>

						<CardContent className={`${styles.businessDetails}`}>
							<div className={`${styles.left} `}>
								<div className={styles.businessAvatar}>
									<img
										src={formData.businessProfilePic}
										alt=""
									/>
								</div>
								<div className={`${styles.businessName}`}>
									<div className={styles.row}>
										<Typography
											sx={{ fontWeight: 'bold' }}
											gutterBottom
											variant="h4"
										>
											{formData.businessName}
										</Typography>

										{formData.topVendor ? (
											<span className={styles.topLabel}>
												<img
													src="/images/vendor-feat-label.svg"
													alt="vendor-feat-label.svg"
												/>
												Top Vendor
											</span>
										) : (
											isMyProfile && (
												<>
													<span
														style={{
															opacity: 0.25,
															backgroundColor:
																'#656565ff',
														}}
														className={
															styles.topLabel
														}
													>
														<img
															src="/images/vendor-feat-label.svg"
															alt="vendor-feat-label.svg"
														/>
														Top Vendor
													</span>
													<ButtonCustom
														size="sm"
														onClick={() => {
															dispatch(
																setSettingsTab(
																	4
																)
															)
															navigate(
																'/settings'
															)
														}}
													>
														Upgrade to boost
														visibility
													</ButtonCustom>
												</>
											)
										)}
									</div>
									<Typography
										color="#7ca6bd"
										gutterBottom
										variant="h6"
									>
										{formData.businessAddress}
									</Typography>
								</div>
							</div>
							<div className={styles.websiteAndChat}>
								{formData.websiteLink && (
									<div className={styles.websiteBtn}>
										<ButtonCustom
											variant="outlined"
											onClick={() => {
												window.location.assign(
													formData.websiteLink
												)
											}}
										>
											<img src="/images/global.svg" />
											<Typography variant="body">
												Website
											</Typography>
											<img src="/images/Link.svg" />
										</ButtonCustom>
									</div>
								)}
								{['user'].includes(accountType) && (
									<>
										{/* TODO: SHOULD WE KEEP THIS? FRIDAY */}
										{/* <div className={styles.chatBtn}>
											<ButtonCustom
												variant="outlined"
												to="/"
											>
												<img src="/images/chat-icon.svg" />
												<Typography variant="body">
													Chat
												</Typography>
											</ButtonCustom>
										</div> */}
										<div className={styles.chatBtn}>
											<ButtonCustom
												variant="default"
												onClick={() =>
													dispatch(
														openModal(
															'requestProposal'
														)
													)
												}
											>
												<img
													src="/images/receipt-edit.svg"
													alt="receipt-edit.svg"
												/>
												<Typography variant="body">
													Request Proposals
												</Typography>
											</ButtonCustom>
										</div>
									</>
								)}
							</div>
						</CardContent>
					</div>
					<div className={styles.bottomContent}>
						{!(sameUser && !formData?.profileCompleted) ? (
							<CardContent className={styles.bottomContentInner}>
								<div className={styles.vendorPublicProfile}>
									<Grid
										container
										alignItems={'unset'}
										spacing={{ xs: 2 }}
									>
										<Grid size={{ xs: 12, lg: 4.5 }}>
											<div>
												<BusinessInfoCard
													formData={formData}
													cardStyle={cardStyle}
													editable={canEditBusinessDetails}
													setFormData={setFormData}
												/>
												<MediaCard
													setFormData={setFormData}
													editable={editable}
													formData={formData}
													cardStyle={cardStyle}
													handleFileChange={
														handleFileChange
													}
												/>
											</div>
										</Grid>
										<Grid size={{ xs: 12, lg: 7.5 }}>
											<div>
												<BusinessDesCard
													formData={formData}
													cardStyle={cardStyle}
													editable={editable}
												/>
												<ServicesCard
													editable={editable}
													formData={formData}
													cardStyle={cardStyle}
												/>
												<SocialProfilesCard
													editable={editable}
													formData={formData}
													cardStyle={cardStyle}
													setFormData={setFormData}
												/>
												<PackagesCard
													cardStyle={cardStyle}
													setSelectedPackage={
														setSelectedPackage
													}
												/>
												<RatingReviewCard
													editable={editable}
													formData={formData}
													cardStyle={cardStyle}
													vendorId={vendorId}
													reviewsData={reviewsData}
												/>
											</div>
										</Grid>
									</Grid>
								</div>
							</CardContent>
						) : (
							<ButtonCustom
								size="lg"
								onClick={() => {
									dispatch(setSettingsTab(5))
									navigate('/settings')
								}}
							>
								Complete your profile!
							</ButtonCustom>
						)}
					</div>
				</div>
			</section>

			<CommonModal
				open={modal === 'addFavoriteVendorModal2'}
				handleClose={closeAllModals}
				heading="Add to Favorites"
				subHeading="Select Wedding to add vendor in favorites"
				footerContent={
					<>
						<ButtonCustom
							onClick={closeAllModals}
							variant="outlined"
							size="lg"
						>
							Cancel
						</ButtonCustom>
						<ButtonCustom
							variant="default"
							size="lg"
							onClick={handleSubmitFav}
						>
							Add
						</ButtonCustom>
					</>
				}
			>
				<WeddingSelect
					setSelectedKazoo={setSelectedKazoo}
					selectedKazoo={selectedKazoo}
					hideDetails={true}
				/>
			</CommonModal>

			<CommonModal
				open={modal === 'requestProposal'}
				handleClose={closeAllModals}
				heading="Request Proposals"
				subHeading="Fill out the form below to request a proposal from this vendor"
				className={styles.VendorsListModalMain}
				subclass={true}
				footerContent={
					<>
						<div className={styles.VendorsListModal}>
							<div className="">
								<Stepper
									totalSteps={3}
									subSteps={3}
									activeStep={activeStep + 1}
								/>
							</div>
							<div className={styles.VendorsListModalButtonGroup}>
								{activeStep > 0 && (
									<ButtonCustom
										variant="link"
										size="lg"
										onClick={handleBack}
									>
										Previous
									</ButtonCustom>
								)}
								{!(activeStep === 2) ? (
									<ButtonCustom
										variant="default"
										size="lg"
										onClick={handleNext}
									>
										Next
									</ButtonCustom>
								) : (
									<ButtonCustom
										variant="default"
										size="lg"
										onClick={() => {
											const addOnIds =
												selectedPackage?.addOnsIds?.filter(
													(addon) =>
														selectedPackage?.selectedAddOns?.includes(
															addon?._id
														)
												)
											const payload = {
												...selectedKazoo,
												kazooId: selectedKazoo._id,
												vendorId: userId,
												...(selectedPackage?._id
													? {
															packageId:
																selectedPackage._id,
														}
													: {}),
												...(selectedPackage?.selectedAddOns
													? {
															addOnIds:
																addOnIds?.map(
																	(addon) => {
																		return {
																			id: addon?._id,
																			quantity:
																				addon?.quantity ||
																				addon?.minQuantity ||
																				1,
																		}
																	}
																),
														}
													: {}),
											}
											dispatch(requestProposal(payload))
											closeAllModals()
										}}
										disabled={!selectedKazoo?.checked}
									>
										Send Proposal
									</ButtonCustom>
								)}
							</div>
						</div>
					</>
				}
			>
				<div>
					{activeStep === 0 && (
						<BudgetRange
							setSelectedKazoo={setSelectedKazoo}
							selectedKazoo={selectedKazoo}
							setSelectedPackage={setSelectedPackage}
							selectedPackage={selectedPackage}
						/>
					)}
					{activeStep === 1 && (
						<WeddingSelect
							setSelectedKazoo={setSelectedKazoo}
							selectedKazoo={selectedKazoo}
						/>
					)}
					{activeStep === 2 && (
						<ProposalSummary
							setSelectedKazoo={setSelectedKazoo}
							selectedKazoo={selectedKazoo}
							selectedPackage={selectedPackage}
						/>
					)}
				</div>
			</CommonModal>
		</>
	)
}
